module.exports = __webpack_public_path__ + "img/60.9661063c.jpg";